import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { showModal } from 'modal.react.js';
import { FieldValues, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import Preview from 'components/Pages/Admin/shared/Preview';
import { TSelectChangeHandler } from 'components/shared/BaseFormComponents/Select/types';
import area from 'components/shared/GlobalModalArea/area';
import Modal from 'components/shared/GlobalModalArea/Modal';
import { itineraryScheduleTypeSelector } from 'store/itinerariesItem/selectors';
import { createOptionFromPageV2 } from 'utils/createOptionFromPage';

import { transferLoadTypes } from '../../../../../constants';
import { getOptionsLoader } from '../../functions';
import { ITransferTripEventModalContentProps } from './types';
import { transferValidationSchema } from './validation';

export function useTransferModalContent(tripEvent: ITransferTripEventModalContentProps['tripEvent']) {
  const loadOptions = getOptionsLoader(transferLoadTypes, createOptionFromPageV2);
  const organizedBy = useSelector(itineraryScheduleTypeSelector);
  const methods = useForm({
    defaultValues: {
      ...tripEvent,
      attachedPage: tripEvent?.attachedPages?.[0],
    } as FieldValues,
    resolver: yupResolver(transferValidationSchema(organizedBy)),
    mode: 'onTouched',
  });
  const isNeedToShowTooltip =
    tripEvent.id && tripEvent.showChangedRoomOrPageTooltip && methods.formState?.dirtyFields?.attachedPage;

  const handleChangeSelect =
    (onChange: (...event: any[]) => void): TSelectChangeHandler =>
    (name, id) => {
      if (id === null && name === null) {
        onChange(undefined);
      } else {
        onChange({ id, name });
      }
    };

  const isDisabled = Object.keys(methods.formState.errors).length !== 0;

  const openPagePreview = (pageId: number) => {
    showModal(area, (res) => (
      <Modal noPadding size="lg" isOpen toClose={res} stopMouseDownPropagation>
        <Preview pageId={pageId} />
      </Modal>
    ));
  };

  return { methods, isDisabled, loadOptions, openPagePreview, handleChangeSelect, isNeedToShowTooltip };
}
